// src/services/api.js
// Write endpoints go through backend Azure Functions:
//   /api/rprsBlob  — workflow entry blob writes (direct SDK)
//   /api/rprsPE    — Practice Engine LA writes (client, job, service)
// Logic App URLs are stored server-side in environment variables — never shipped to the browser.

const BLOB_ENDPOINT = '/api/rprsBlob';
const PE_ENDPOINT   = '/api/rprsPE';

function postJSON(url, payload) {
  return fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export function formatTimestampWithTz(d = new Date()) {
  // Example: "2025-11-13T19:39:51.081Z"
  return d.toISOString();
}

/**
 * Write a single workflow entry to rprs.WorkflowEntries (SQL) via Azure Function.
 * `entry` is already in final JSON shape (KEY, WORKFLOW, CLIENTCODE, etc.).
 */
export async function writeWorkflowEntry(entry) {
  const res = await postJSON('/api/rprsWorkflow?action=write', { data: entry });
  if (!res.ok) {
    const t = await res.text().catch(() => '');
    throw new Error(`Workflow write failed: ${res.status} ${res.statusText} ${t.slice(0, 200)}`);
  }
  return res.json().catch(() => ({}));
}

// Generic "writeToPE" that picks the right PE Logic App via the backend proxy
export async function writeToPE(kind, payload) {
  const validKinds = ['client', 'service'];   // 'job' removed 2026-10-30 (see api/rprsPE)
  if (!validKinds.includes(kind)) {
    throw new Error(`writeToPE: unknown kind '${kind}'`);
  }

  // Fill in defaults for the envelope if caller didn't
  const nowIso = new Date().toISOString();
  const fullPayload = {
    correlationId:
      payload.correlationId ??
      (crypto?.randomUUID?.() ?? `rprs-${Date.now()}`),
    submittedBy: payload.submittedBy ?? "unknown",
    submittedTs: payload.submittedTs ?? nowIso,
    items: payload.items ?? [],
  };

  console.log("writeToPE kind:", kind, "fullPayload:", fullPayload);

  const res = await postJSON(`${PE_ENDPOINT}?kind=${kind}`, fullPayload);

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(
      `PE Logic App (${kind}) returned ${res.status} ${
        res.statusText
      }: ${text.slice(0, 500)}`
    );
  }

  try {
    return await res.json();
  } catch {
    return null;
  }
}
